"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedLogger = exports.EMPTY_FUNCTION = void 0;
const EMPTY_FUNCTION = () => { };
exports.EMPTY_FUNCTION = EMPTY_FUNCTION;
class NamedLogger {
    get name() { return this._name; }
    constructor(name) {
        this.log = null;
        this.warn = null;
        this.error = null;
        this._name = null;
        this._name = name;
        this.disable();
    }
    enable(overrideName = null) {
        this._name = overrideName || this._name;
        this.log = this._name
            ? (...args) => this.implementation.log(this._name, ...args)
            : this.implementation.log;
        this.warn = this._name
            ? (...args) => this.implementation.warn(this._name, ...args)
            : this.implementation.warn;
        this.error = this._name
            ? (...args) => this.implementation.error(this._name, ...args)
            : this.implementation.error;
        return this;
    }
    disable() {
        this.log = exports.EMPTY_FUNCTION;
        this.warn = exports.EMPTY_FUNCTION;
        this.error = exports.EMPTY_FUNCTION;
        return this;
    }
}
exports.NamedLogger = NamedLogger;
//# sourceMappingURL=named.js.map